export default {
  getMessage() {
    return 'This field is required';
  },
  validate(value) {
    return value.value !== null;
  }
};
